import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class CancelClaimDto {
  @Field(t => Int)
  claimId!: number

  @Field(t => Int)
  type!: number

  @Field({ nullable: true })
  reason?: string

  @Field({ nullable: true })
  additionalInformation?: string

  public constructor (data: CancelClaimDto) {
    Object.assign(this, data)
  }
}
